import React from 'react';
import loader from '../../assets/common/loader.gif';
import Text from './Form/Text';


const styles = {
  container: {
    fontSize: '1.2em',
    color: 'var(--text-color-2)',
    paddingTop: '30px',
  },
  loader: {
    textAlign: 'center',
    margin: '36px 26px',
  },
  image: {
    width: '100px',
    height: 'auto',
  },
  text: {
    display: 'inline-block',
    textAlign: 'center',
    maxWidth: '410px',
    lineHeight: '1.5',
  }
}

const Loader = ({ message = 'Estamos procesando tu solicitud, por favor espera unos segundos..' }) => (
	<div style={message !== '' ? styles.container : {}}>
    <div style={styles.loader}>
      <img style={styles.image} src={loader} alt="" />
    </div>
    <Text style={styles.text}> { message } </Text>
  </div>
);

export default Loader;
